import { StackScreenProps } from "@react-navigation/stack";
import { CreateNewApiVaultKeyRootParamList } from "../../../../types";
import { useTranslation } from "react-i18next";
import { Page } from "@towersystems/roam-common-native";
import { ApiVaultKeyForm } from "../../components/ApiVaultKeyForm";

export interface SelectApiKeyTypeScreenProps
  extends StackScreenProps<
    CreateNewApiVaultKeyRootParamList,
    "SelectApiKeyTypeScreen"
  > {}

export const SelectApiKeyTypeScreen = ({
  navigation,
}: SelectApiKeyTypeScreenProps) => {
  const { t } = useTranslation("api_key_vault");

  return (
    <Page
      title={t("title.select_api_key_type")}
      secondaryTitle={t("title.select_api_key_type_secondary")}
    >
      <ApiVaultKeyForm.SelectKeyType onSelect={() => navigation.goBack()} />
    </Page>
  );
};
